import { uuid } from 'src/shared/helpers';
import { RelayFragment } from 'src/shared/types';
import { productFragment_model$data } from '../state/queries/__generated__/productFragment_model.graphql';

/**
 * Side used to refer to Sides table and not the ModelSide.
 * This will help us track the ModelSide <=> Side relationship.
 *
 * If we want add a new side to a variation we can either add an existing Side or we must create one before
 * and assign the originalSide to the modelSide.
 */
export interface Side {
    sideID: number | null;
    name: string;
    guid: string;
}

/**
 * Help extracts all the Side[] from a query model variations.
 * @param model The query model
 */
export function getAllSidesFromQueryModel(model: Omit<RelayFragment<productFragment_model$data>, ' $fragmentType'>) {
    const sides: Side[] = [];

    for (const modelColor of model.colors) {
        for (const modelSide of modelColor.sides) {
            if (!sides.find((side) => side.sideID == modelSide.sideID)) {
                const side: Side = {
                    sideID: modelSide.sideID,
                    name: modelSide.name,
                    guid: uuid()
                };
                sides.push(side);
            }
        }
    }

    return sides;
}
